import React, { Fragment } from "react";
import {
  Combobox,
  Dialog,
  Menu,
  Transition,
  Disclosure,
} from "@headlessui/react";
import { Link, Navigate, useParams } from "react-router-dom";
import mainLogo from "../mglogo.png";
import {
  ArchiveIcon,
  BellIcon,
  MenuAlt2Icon,
  PlusIcon,
  ShoppingBagIcon,
  UsersIcon,
  XIcon,
  ClipboardIcon,
  ShoppingCartIcon,
  TemplateIcon,
  FolderIcon,
  DocumentIcon,
  HomeIcon,
  PlusSmIcon as PlusSmIconOutline,
  XCircleIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  CheckIcon,
  SearchIcon,
  SelectorIcon,
  PlusSmIcon as PlusSmIconSolid,
  ColorSwatchIcon,
  CogIcon,
} from "@heroicons/react/solid";
import axios from "axios";
import Customercreatemodal from "./Customercreatemodal";
import ItemModalcreate from "./ItemModalcreate";
import Customervehiclemodalcreate from "./Customervehiclemodalcreate";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class EnquireEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      logoutRedirect: false,
      customer_id: "",
      customerDetails: "",
      opencustomer: false,
      openitem: false,
      customerEnquireOrLead:2,
      branch_id: "",
      warehouse_id: "",
      lead_id: "",
      queryLead:"",
      enquire_date: "",
      employee_id: "",
      payment_terms_id: "",
      expiry_date: "",
      salesperson: "Dreams",
      subject: "enquire",
      vehicle_information_id: "",
      customer_notes: "",
      terms_conditions: "",
      sub_total: "",
      tds_tcs_option_id: "",
      tds_tcs_id: "",
      tds_tcs_rate: "",
      adjustment_name: "",
      adjustment_value: "",
      total_tax_amount: "",
      total: "",
      balance_due: 0,

      enquireNumber: "",
      enquire_date: "",
      expiry_date: "",
      message1:"Successfully Saved",
      totalTax: 0,
      opencustomervehicle: false,
      vechicle_information: "",
      enquireTaxlist: [],
      enquire_item: [
        {
          name: "",
          item_id: "",
          description: "",
          quantity: 1,
          hsn_code: "",
          discount_symbol_id: 1,
          discount_number: 0,
          rate: 0,
          enquireTaxpercent: 0,
          enquire_tax_id: 0,
          enquire_tax_orgin_percentage: 0,
          gst_igst_common_value: 0,
          cgst_percentage: 0,
          cgst_amount: 0,
          sgst_percentage: 0,
          sgst_amount: 0,
          igst_percentage: 0,
          igst_amount: 0,
          amount: 0,
        },
      ],
      customerList: [],
      itemLine: [],
      termsList: [],
      branchList: [],
      error_list: [],
      discountList: [],
      warehouseList: [],
      vechicleList: [],
      employeeList: [],
      leadList:[],
      selectedLead:"",
      enquire_item_delete:[],
      query: "",
      queryItem: "",
      selectedPerson: "",
      selectedReference: "",
      reference_id:"",
      selectedItems: "",
      showstockmsg: false,
      stockmsg: "",
      loader: "",
      overLay: "",
      urlUpdate: true,
      leadDetails:[]
    };
    this.handleInput = this.handleInput.bind(this);
    //this.addLine = this.addLine.bind(this);
  }

  setLoaderFunction = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "fixed inset-0 bg-black/30",
    });
  };

  closeLoaderFuncion = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "",
    });
  };

  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };

  open = async (e) => {
    this.setState({ sidebarOpen: true });
  };

  componentDidMount() {
    this.setLoaderFunction();
    const token = localStorage.getItem("token");
    const { id } = this.props.params;
    let branchI = 0;

    const ress = axios
      .get("public/api/enquire/edit/" + id, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((ress) => {
        this.state.enquire_item = [];
        branchI = ress.data.enquire.branch_id;
        ress.data.enquire.enquire_item.map((value, index) => {
          let orginTaxpercent = 0;

          if (value.gst_igst_common_value == 3) {
            orginTaxpercent = value.cgst_percentage * 2;
          }

          if (value.gst_igst_common_value == 2) {
            orginTaxpercent = value.igst_percentage;
          }

          this.state.enquire_item.push({
            name: value.name,
            id: value.id,
            item_id: value.item_id,
            description: value.description,
            hsn_code: value.hsn_code,
            quantity: value.quantity,
            discount_symbol_id: value.discount_symbol_id,
            discount_number: value.discount_number,
            rate: value.rate,
            enquireTaxpercent: 0,
            enquire_tax_id: value.enquire_tax_id,
            enquire_tax_orgin_percentage: orginTaxpercent,
            gst_igst_common_value: value.gst_igst_common_value,
            cgst_percentage: value.cgst_percentage,
            cgst_amount: value.cgst_amount,
            sgst_percentage: value.sgst_percentage,
            sgst_amount: value.sgst_amount,
            igst_percentage: value.igst_percentage,
            igst_amount: value.igst_amount,
            amount: value.amount,
          });
        });

        this.setState({
          enquireDetails: ress.data.enquire,
          leadDetails:ress.data.enquire.lead,
          //customer_id: ress.data.enquire.customer.id,
          lead_id:ress.data.enquire.lead.id,
          branch_id: ress.data.enquire.branch_id,
          enquireNumber: ress.data.enquire.transaction_series_number,
         
          employee_id: ress.data.enquire.employee_id,
          enquire_date: ress.data.enquire.enquire_date,
          expiry_date:ress.data.enquire.expiry_date,
          enquire_item: this.state.enquire_item,
          //customerDetails: ress.data.enquire.customer,
          total: ress.data.enquire.total,
          sub_total: ress.data.enquire.sub_total,
          customer_notes: ress.data.enquire.customer_notes,
        });
console.log(ress.data.enquire.lead);
        this.calculateSubTotalTotal();
      });

    const res = axios
      .get("public/api/customers", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        this.setState({ customerList: res.data.customers });
      });

    const res2 = axios
      .get("public/api/paymentterms", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res2) => {
        this.setState({ termsList: res2.data.paymentterms });
      });

    const res3 = axios
      .get("public/api/invoice/tax/option", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res3) => {
        this.setState({ enquireTaxlist: res3.data.invoice_tax_option });
      });

    const res11 = axios
      .get("public/api/items", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res11) => {
        this.setState({ itemLine: res11.data.items });
      });

    const res12 = axios
      .get("public/api/branch", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res12) => {
        this.setState({ branchList: res12.data.branches });
      });

    const res13 = axios
      .get("public/api/invoice/discount/symbol", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res13) => {
        this.setState({ discountList: res13.data.discount_symbols });
      });

    const resItem = axios
      .get("public/api/items", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((resItem) => {
        this.setState({
          itemLine: resItem.data.items,
        });
      });
    const res14 = axios
      .get("public/api/employees", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res14) => {
        this.setState({ employeeList: res14.data.employees });
      });
      const resLead = axios
      .get("public/api/leads", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((resLead) => {
        this.setState({leadList: resLead.data.leads });
      });
    setTimeout(
      function () {
        //Start the timer
        this.closeLoaderFuncion();
        this.setState({ loader: "" }); //After 1 second, set render to true
      }.bind(this),
      500
    );
  }

  handleInput = (e) => {
    this.setState({
      customerDetails: e,
    });
    this.setState({ customer_id: e.id });
  };

  handleInputSelectItem = (enquireItemIndex) => (e) => {
    this.state.enquire_item[enquireItemIndex].name = e.name;
    this.state.enquire_item[enquireItemIndex].item_id = e.id;
    this.state.enquire_item[enquireItemIndex].rate = e.sales_selling_price;
    this.state.enquire_item[enquireItemIndex].amount = e.sales_selling_price;
    this.state.enquire_item[enquireItemIndex].quantity = 1;
    this.calculateTax(enquireItemIndex);
  };

  handleInputSelectquantity = (enquireItemIndex) => (e) => {
    let qty = e.target.value;
    this.state.enquire_item[enquireItemIndex].quantity = qty;

    this.calculateTax(enquireItemIndex);
  };

  handleInputAmount = (enquireItemIndex) => (e) => {
    let price = e.target.value;
    this.state.enquire_item[enquireItemIndex].rate = price;

    this.calculateTax(enquireItemIndex);
  };

  handleenquiretax = (enquireItemIndex) => (e) => {
    const taxId = parseInt(e.target.value);

    if (taxId != 0) {
      //we get taxlist primerykey through dropdown menu but we need gst_igst_common and percentage for calculations that's why we get taxObject from enquireTaxlist Array
      const index = this.state.enquireTaxlist.findIndex(
        (item) => item.id === taxId
      );
      const Tax = this.state.enquireTaxlist[index];
      this.state.enquire_item[enquireItemIndex].gst_igst_common_value =
        Tax.gst_igst_common;
      this.state.enquire_item[enquireItemIndex].enquire_tax_id = taxId;
      this.state.enquire_item[enquireItemIndex].enquire_tax_orgin_percentage =
        Tax.percentage;

      this.calculateTax(enquireItemIndex);
    } else {
      this.state.enquire_item[enquireItemIndex].enquire_tax_id = 0;
      this.calculateTax(enquireItemIndex);
    }
  };

  calculateTax(enquireItemIndex) {
    //This is GST and IGST calculation
    if (this.state.enquire_item[enquireItemIndex].enquire_tax_id != 0) {
      let qty = this.state.enquire_item[enquireItemIndex].quantity;
      let amount = this.state.enquire_item[enquireItemIndex].rate;
      let percentageOrgin =
        this.state.enquire_item[enquireItemIndex].enquire_tax_orgin_percentage;

      if (
        this.state.enquire_item[enquireItemIndex].gst_igst_common_value == 2
      ) {
        let tamount = qty * amount;
        let Taxamount = ((tamount / 100) * percentageOrgin).toFixed(2);

        this.state.enquire_item[enquireItemIndex].igst_amount = Taxamount;
        this.state.enquire_item[enquireItemIndex].igst_percentage =
          percentageOrgin;
      }

      if (
        this.state.enquire_item[enquireItemIndex].gst_igst_common_value === 3
      ) {
        let percentage = (percentageOrgin / 2).toFixed(2);
        let tamount = qty * amount;
        let Taxamount = ((tamount / 100) * percentage).toFixed(2);

        this.state.enquire_item[enquireItemIndex].cgst_amount = Taxamount;
        this.state.enquire_item[enquireItemIndex].sgst_amount = Taxamount;
        this.state.enquire_item[enquireItemIndex].sgst_percentage = percentage;
        this.state.enquire_item[enquireItemIndex].cgst_percentage = percentage;
      }

      if (
        this.state.enquire_item[enquireItemIndex].gst_igst_common_value === 1
      ) {
        this.state.enquire_item[enquireItemIndex].igst_amount = 0;
        this.state.enquire_item[enquireItemIndex].igst_percentage = 0;
        this.state.enquire_item[enquireItemIndex].cgst_amount = 0;
        this.state.enquire_item[enquireItemIndex].sgst_amount = 0;
        this.state.enquire_item[enquireItemIndex].sgst_percentage = 0;
        this.state.enquire_item[enquireItemIndex].cgst_percentage = 0;
      }
    }

    if (this.state.enquire_item[enquireItemIndex].enquire_tax_id == 0) {
      this.state.enquire_item[enquireItemIndex].igst_amount = 0;
      this.state.enquire_item[enquireItemIndex].igst_percentage = 0;
      this.state.enquire_item[enquireItemIndex].cgst_amount = 0;
      this.state.enquire_item[enquireItemIndex].sgst_amount = 0;
      this.state.enquire_item[enquireItemIndex].sgst_percentage = 0;
      this.state.enquire_item[enquireItemIndex].cgst_percentage = 0;
      this.state.enquire_item[enquireItemIndex].gst_igst_common_value = 0;
      this.state.enquire_item[
        enquireItemIndex
      ].enquire_tax_orgin_percentage = 0;
    }

    this.state.enquire_item[enquireItemIndex].amount =
      this.state.enquire_item[enquireItemIndex].quantity *
      this.state.enquire_item[enquireItemIndex].rate;

    this.calculateSubTotalTotal();
  }

  calculateSubTotalTotal() {
    let totalTax = 0;
    let subTotal = 0;

    this.state.enquire_item.map((item, sidx) => {
      if (item.gst_igst_common_value === 3) {
        totalTax = totalTax + parseFloat(item.cgst_amount);
        totalTax = totalTax + parseFloat(item.sgst_amount);
      }

      if (item.gst_igst_common_value === 2) {
        totalTax = totalTax + parseFloat(item.igst_amount);
      }

      subTotal = subTotal + parseFloat(item.amount);
    });

    this.setState({ sub_total: subTotal });
    this.setState({ totalTax: totalTax });
    this.setState({ enquire_item: this.state.enquire_item });
  }

  handleInputDescription = (index) => (e) => {
    const itemsP = this.state.enquire_item.map((item, sidx) => {
      if (index !== sidx) {
        return item;
      }

      return { ...item, description: e.target.value };
    });

    this.setState({ enquire_item: itemsP });
  };

  handleInputSelecthsn_code = (index) => (e) => {
    const itemsP = this.state.enquire_item.map((item, sidx) => {
      if (index !== sidx) {
        return item;
      }

      return { ...item, hsn_code: e.target.value };
    });

    this.setState({ enquire_item: itemsP });
  };

  handleInputenquiredetails = (e) => {
    const token = localStorage.getItem("token");
    if (e.target.name === "branch_id") {
      this.setLoaderFunction();
      this.setState({ loader: "animate-pulse" });
      const res = axios
        .get("public/api/branch/warehouse/" + e.target.value, {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          this.setState({ loader: "" });
          this.setState({ warehouseList: res.data.warehouses });
        });
      this.closeLoaderFuncion();
    }

    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleInputOne = (e) => {
    this.setState({
      query: e.target.value,
    });
  };

  handleInputtwo = (e) => {
    this.setState({
      queryItem: e.target.value,
    });
  };


  
  handleInputreference = (e) => {
  
    this.setLoaderFunction();
    this.setState({
      selectedReference: e,
    });
    this.setState({ reference_id: e.id }); 
     console.log("as");
     console.log(e.id );
    this.closeLoaderFuncion();
  };

  saveItem = async (e) => {
   
    this.setLoaderFunction();
    e.preventDefault();

    const { id } = this.props.params;
   

    if (this.state.enquire_item.length > 0) {
      
        var token = localStorage.getItem("token");
        const headers = {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        };

        const res = await axios.post(
          "public/api/enquire/update/" + id,
          this.state,
          { headers }
        );

        if (res.data.success) {
          this.setState({ showmsg: true });

          setTimeout(
            function () {
              //Start the timer
              this.closeLoaderFuncion();
              this.setState({ redirect: true }); //After 1 second, set render to true
            }.bind(this),
            1000
          );
        } else {
          this.closeLoaderFuncion();
          if (res.data.data != undefined) {
            this.closeLoaderFuncion();
            this.setState({ error_list: res.data.data });
            this.setState({ show: true });

            if (res.data.data.enquire_item) {
              this.setState({ showstockmsg: true });
              this.setState({
                stockmsg: res.data.data.enquire_item,
              });
            }
            if (res.data.data.gst_igst_common_value[0]) {
              this.setState({ iconStatus: false });
              this.setState({ showmsg: true });
              this.setState({
                message1: res.data.data.gst_igst_common_value[0],
              });
              setTimeout(
                function () {
                  this.closeLoaderFuncion();
                  this.setState({ showmsg: false });
                  this.setState({ iconStatus: true });
                  this.setState({ message1: "Successfully Saved" });
                }.bind(this),
                2000
              );
            }
          } else {
            this.setState({ showstockmsg: true });
            this.setState({ stockmsg: res.data.message });
            this.error_list = [];
          }
        }
      
    }

    if (this.state.enquire_item.length === 0) {
      this.setState({ showstockmsg: true });
      this.setState({
        stockmsg: "enquire item cannot be empty",
      });
    }

   
    this.closeLoaderFuncion();
  };

  itemDelete = (enquireItemIndex) => (e) => {
    let getenquireItemId = this.state.enquire_item[enquireItemIndex]["id"];

    if (getenquireItemId !== undefined) {
      this.state.enquire_item_delete.push({ id: getenquireItemId });
    }

    this.state.enquire_item = this.state.enquire_item.filter(
      (s, sidx) => enquireItemIndex !== sidx
    );
    this.calculateSubTotalTotal();

    this.setState({
      enquire_item: this.state.enquire_item,
    });
  };

  addLine = (e) => {
    this.setState({
      enquire_item: this.state.enquire_item.concat([
        {
          name: "",
          hsn_code: "",
          item_id: "",
          description: "",
          quantity: 1,
          discount_symbol_id: 1,
          discount_number: 0.0,
          rate: 0,
          enquireTaxpercent: 0,
          enquire_tax_id: 0,
          enquire_tax_orgin_percentage: 0,
          gst_igst_common_value: 0,
          cgst_percentage: 0,
          cgst_amount: 0,
          sgst_percentage: 0,
          sgst_amount: 0,
          igst_percentage: 0,
          igst_amount: 0,
          amount: 0,
        },
      ]),
    });
  };

  addcustomer = (e) => {
    this.setState({ opencustomer: true });
  };

  closecustomer = (e) => {
    this.setState({ opencustomer: false });
  };

  addItem = (e) => {
    this.setState({ openitem: true });
  };
  closeItem = (e) => {
    this.setState({ openitem: false });
  };

  handleInputModal = (e) => {
    this.state.customerList = [];
    if (e) {
      this.setState({ openvendor: false });
      const token = localStorage.getItem("token");
      const res = axios
        .get("public/api/customers", {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          this.setState({ customerList: res.data.customers });
          this.setState({ opencustomer: false });
        });
    }
  };

  handleInputModalForItem = async (e) => {
    this.state.itemLine = [];
    if (e) {
      this.setState({ openvendor: false });
      const token = localStorage.getItem("token");
      const res = axios
        .get("public/api/items", {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          this.setState({ openitem: false });
          this.setState({ itemLine: res.data.items });
        });
    }
  };

  ItemErrorfetch(error_list, index) {
    var pea = `enquire_item.${index}.enquire_tax_id`;
    return error_list[pea];
  }

  handleInputLead = (e) => {
    this.setLoaderFunction();
    this.setState({
      leadDetails: e,
    });
    this.setState({ lead_id: e.id });
    this.closeLoaderFuncion();
  };


  handleInputOneLead = (e) => {
    this.setState({
      queryLead: e.target.value,
    });
  };

  //Logout function

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("public/api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    //console.log(res);

    if (res.data.success) {
      localStorage.removeItem("token");

      //Start the timer
      this.setState({ logoutRedirect: true }); //After 1 second, set render to true
    }
  };

  //Logout function

  render() {
    const cancelButtonRef = null;

    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.redirect) {
      this.state.redirect = false;
      this.setState({ redirect: this.state.redirect });
      return <Navigate to={"/filterby/EnquireList"} />;
    }

    const filteredPeople =
      this.state.query === ""
        ? this.state.customerList
        : this.state.customerList.filter((customerList) => {
            return customerList.customer_display_name
              .toLowerCase()
              .includes(this.state.query.toLowerCase());
          });
          
    
    const filteredItem =
      this.state.queryItem === ""
        ? this.state.itemLine
        : this.state.itemLine.filter((itemLine) => {
            return itemLine.name
              .toLowerCase()
              .includes(this.state.queryItem.toLowerCase());
          });

          const filteredLead =
    this.state.queryLead === ""
      ? this.state.leadList
      : this.state.leadList.filter((leadList) => {
          return leadList.phone
            .toLowerCase()
            .includes(this.state.queryLead.toLowerCase());
        });

    return (
      <>
        {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-gray-100">
        <body class="h-full">
        ```
      */}
        <div>
          <div className={this.state.overLay} aria-hidden="true" />

          {/* Static sidebar for desktop */}

          <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            <h1 className="text-2xl font-semibold text-gray-900">
              Update enquire
            </h1>
          </div>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            {/* Replace with your content */}

            <div className="hidden sm:block" aria-hidden="true">
              <div className="py-5">
                <div className="border-t border-gray-200" />
              </div>
            </div>
            <div className={`mt-10 sm:mt-0 ${this.state.loader}`}>
              <div className="md:grid md:gap-6">
                <div className="mt-5 md:mt-0 md:col-span-2">
                  <form onSubmit={this.saveItem}>
                    <div className="shadow overflow-hidden sm:rounded-md">
                      <div className="px-4 py-5 bg-white sm:p-6">
                        <div className="grid grid-cols-6 gap-6">
                          {/*start*/}

                          {this.state.customerEnquireOrLead===2?(
                            <><div className="col-span-6 sm:col-span-6 lg:col-span-3">
                            <Combobox
                              as="div"
                              name="lead_id"
                              value={this.state.leadDetails}
                              onChange={this.handleInputLead}
                            >
                              <Combobox.Label className="block text-sm font-medium text-gray-700">
                                <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  Lead
                                </span>
                              </Combobox.Label>
                              <div className="relative mt-1">
                                <Combobox.Input
                                  className="w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
                                  onChange={this.handleInputOneLead}
                                  displayValue={(lead) =>
                                    typeof lead.phone !==
                                      "undefined" &&
                                      lead.phone != null
                                      ? lead.phone
                                      : ""
                                  }
                                />
                                <Combobox.Button className="absolute inset-y-0 right-9 flex items-center rounded-r-md px-2 focus:outline-none">
                                  <SelectorIcon
                                    className="h-5 w-5 text-gray-400"
                                    aria-hidden="true"
                                  />
                                </Combobox.Button>
  
                                {filteredLead.length > 0 && (
                                  <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                    {filteredLead.map((lead) => (
                                      <Combobox.Option
                                        key={lead.id_crypt}
                                        value={lead}
                                        className={({ active }) =>
                                          classNames(
                                            "relative cursor-default select-none py-2 pl-3 pr-9",
                                            active
                                              ? "bg-indigo-600 text-white"
                                              : "text-gray-900"
                                          )
                                        }
                                      >
                                        {({ active, selected }) => (
                                          <>
                                            <span
                                              className={classNames(
                                                "block truncate",
                                                selected && "font-semibold"
                                              )}
                                            >
                                              {lead.phone}{"&"}{lead.name}
                                            </span>
  
                                            {selected && (
                                              <span
                                                className={classNames(
                                                  "absolute inset-y-0 right-0 flex items-center pr-4",
                                                  active
                                                    ? "text-white"
                                                    : "text-indigo-600"
                                                )}
                                              >
                                                <CheckIcon
                                                  className="h-5 w-5"
                                                  aria-hidden="true"
                                                />
                                              </span>
                                            )}
                                          </>
                                        )}
                                      </Combobox.Option>
                                    ))}
                                  </Combobox.Options>
                                )}
                              </div>
                            </Combobox>
                            <p
                              className="mt-2 text-sm text-red-600"
                              id="email-error"
                            >
                              {this.state.error_list.customer_id}
                            </p>
                          </div>
                          
                          </>
                          ):( <>
                           <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                            <Combobox
                              as="div"
                              name="customer_id"
                              value={this.state.customerDetails}
                              onChange={this.handleInput}
                            >
                              <Combobox.Label className="block text-sm font-medium text-gray-700">
                                <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  Customer
                                </span>
                              </Combobox.Label>
                              <div className="relative mt-1">
                                <Combobox.Input
                                  className="w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
                                  onChange={this.handleInputOne}
                                  displayValue={(cutomer) =>
                                    typeof cutomer.customer_display_name !==
                                      "undefined" &&
                                    cutomer.customer_display_name != null
                                      ? cutomer.customer_display_name
                                      : ""
                                  }
                                />
                                <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
                                  <SelectorIcon
                                    className="h-5 w-5 text-gray-400"
                                    aria-hidden="true"
                                  />
                                </Combobox.Button>

                                {filteredPeople.length > 0 && (
                                  <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                    {filteredPeople.map((customer) => (
                                      <Combobox.Option
                                        key={customer.id_crypt}
                                        value={customer}
                                        className={({ active }) =>
                                          classNames(
                                            "relative cursor-default select-none py-2 pl-3 pr-9",
                                            active
                                              ? "bg-indigo-600 text-white"
                                              : "text-gray-900"
                                          )
                                        }
                                      >
                                        {({ active, selected }) => (
                                          <>
                                            <span
                                              className={classNames(
                                                "block truncate",
                                                selected && "font-semibold"
                                              )}
                                            >
                                              {customer.customer_display_name}
                                            </span>

                                            {selected && (
                                              <span
                                                className={classNames(
                                                  "absolute inset-y-0 right-0 flex items-center pr-4",
                                                  active
                                                    ? "text-white"
                                                    : "text-indigo-600"
                                                )}
                                              >
                                                <CheckIcon
                                                  className="h-5 w-5"
                                                  aria-hidden="true"
                                                />
                                              </span>
                                            )}
                                          </>
                                        )}
                                      </Combobox.Option>
                                    ))}
                                  </Combobox.Options>
                                )}
                              </div>
                            </Combobox>
                            <p
                              className="mt-2 text-sm text-red-600"
                              id="email-error"
                            >
                              {this.state.error_list.customer_id}
                            </p>
                          </div>
                        <div className="col-span-6 sm:col-span-6 lg:col-span-1">
                        <button
                          type="button"
                          onClick={this.addcustomer}
                          className="mt-5 inline-flex items-center p-2 border border-transparent rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        >
                          <PlusSmIconOutline
                            className="h-6 w-6"
                            aria-hidden="true"
                          />
                        </button>
                      </div>
                      <div className="col-span-6 sm:col-span-6 lg:col-span-1">
                            <button
                              type="button"
                              onClick={this.addcustomer}
                              className="mt-5 inline-flex items-center p-2 border border-transparent rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            >
                              <PlusSmIconOutline
                                className="h-6 w-6"
                                aria-hidden="true"
                              />
                            </button>
                          </div>
                        </>
                        )}
                         
                          
                          <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                            <label
                              htmlFor="branch_id"
                              className="block text-sm font-medium text-gray-700"
                            >
                              <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                Branch:
                              </span>
                            </label>
                            <select
                              id="branch_id"
                              name="branch_id"
                              value={this.state.branch_id}
                              onChange={this.handleInputenquiredetails}
                              className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                            >
                              <option value="0">------</option>
                              {this.state.branchList.map((number) => (
                                <option value={number.id}>{number.name}</option>
                              ))}
                            </select>
                            <p
                              className="mt-2 text-sm text-red-600"
                              id="email-error"
                            >
                              {this.state.error_list.branch_id}
                            </p>
                          </div>
                          
                          <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                            <label
                              htmlFor="enquireNumber"
                              className="block text-sm font-medium text-gray-700"
                            >
                              Enquire Number
                            </label>
                            <input
                              type="text"
                              name="enquireNumber"
                              id="enquireNumber"
                              disabled
                              value={this.state.enquireNumber}
                              onChange={this.handleInputenquiredetails}
                              autoComplete="enquireNumber"
                              className="mt-1 focus:ring-indigo-500 disabled:bg-slate-50 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                            />
                            <p
                              className="mt-2 text-sm text-red-600"
                              id="enquireNumber-error"
                            >
                              {this.state.error_list.enquireNumber}
                            </p>
                          </div>

                          <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                            <label
                              htmlFor="enquire_date"
                              className="block text-sm font-medium text-gray-700"
                            >
                              {" "}
                              <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                Enquire Date
                              </span>
                            </label>
                            <input
                              type="Date"
                              name="enquire_date"
                              id="enquire_date"
                              value={this.state.enquire_date}
                              onChange={this.handleInputenquiredetails}
                              autoComplete=""
                              className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                            />
                            <p
                              className="mt-2 text-sm text-red-600"
                              id="enquire_date-error"
                            >
                              {this.state.error_list.enquire_date}
                            </p>
                          </div>

                          <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                            <label
                              htmlFor="expiry_date"
                              className="block text-sm font-medium text-gray-700"
                            >
                              <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                Enquire Expire Date
                              </span>
                            </label>
                            <input
                              type="Date"
                              name="expiry_date"
                              id="expiry_date"
                              value={this.state.expiry_date}
                              onChange={this.handleInputenquiredetails}
                              autoComplete="expiry_date"
                              className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                            />
                            <p
                              className="mt-2 text-sm text-red-600"
                              id="expiry_date-error"
                            >
                              {this.state.error_list.expiry_date}
                            </p>
                          </div>

                          <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                            <label
                              htmlFor="employee_id"
                              className="block text-sm font-medium text-gray-700"
                            >
                              Employee
                            </label>
                            <select
                              id="employee_id"
                              name="employee_id"
                              value={
                                this.state.employee_id
                                  ? this.state.employee_id
                                  : ""
                              }
                              onChange={this.handleInputenquiredetails}
                              className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                            >
                              <option value="0">------</option>
                              {this.state.employeeList.map((number) => (
                                <option value={number.id}>{number.name}</option>
                              ))}
                            </select>
                            <p
                              className="mt-2 text-sm text-red-600"
                              id="employee_id-error"
                            >
                              {this.state.error_list.employee_id}
                            </p>
                          </div>

                          <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                            <label
                              htmlFor="reference_id"
                              className="block text-sm font-medium text-gray-700"
                            >
                              
                            </label>
                                <Combobox
                                as="div"
                                name="reference_id"
                                value={this.state.selectedReference}
                                onChange={this.handleInputreference}
                                >
                                <Combobox.Label className="block text-sm font-medium text-gray-700">
                                  <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                    Referred by
                                  </span>
                                </Combobox.Label>
                                <div className="relative mt-1">
                                  <Combobox.Input
                                    className="w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
                                    onChange={this.handleInputOne}
                                    displayValue={(cutomer) =>
                                      typeof cutomer.customer_display_name !==
                                        "undefined" &&
                                      cutomer.customer_display_name != null
                                        ? cutomer.customer_display_name
                                        : ""
                                    }
                                  />
                                  <Combobox.Button className="absolute inset-y-0 right-9 flex items-center rounded-r-md px-2 focus:outline-none">
                                    <SelectorIcon
                                      className="h-5 w-5 text-gray-400"
                                      aria-hidden="true"
                                    />
                                  </Combobox.Button>

                                  {filteredPeople.length > 0 && (
                                    <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                      {filteredPeople.map((customer) => (
                                        <Combobox.Option
                                          key={customer.id_crypt}
                                          value={customer}
                                          className={({ active }) =>
                                            classNames(
                                              "relative cursor-default select-none py-2 pl-3 pr-9",
                                              active
                                                ? "bg-indigo-600 text-white"
                                                : "text-gray-900"
                                            )
                                          }
                                        >
                                          {({ active, selected }) => (
                                            <>
                                              <span
                                                className={classNames(
                                                  "block truncate",
                                                  selected && "font-semibold"
                                                )}
                                              >
                                                {customer.customer_display_name}
                                              </span>

                                              {selected && (
                                                <span
                                                  className={classNames(
                                                    "absolute inset-y-0 right-0 flex items-center pr-4",
                                                    active
                                                      ? "text-white"
                                                      : "text-indigo-600"
                                                  )}
                                                >
                                                  <CheckIcon
                                                    className="h-5 w-5"
                                                    aria-hidden="true"
                                                  />
                                                </span>
                                              )}
                                            </>
                                          )}
                                        </Combobox.Option>
                                      ))}
                                    </Combobox.Options>
                                  )}
                                </div>
                              </Combobox>
                            <p
                              className="mt-2 text-sm text-red-600"
                              id="reference_id-error"
                            >
                              {this.state.error_list.reference_id}
                            </p>
                          </div>

                          <div className="col-span-6 sm:col-span-6 lg:col-span-6">
                            <div className="-mx-4 mt-8 flex flex-col sm:-mx-6 md:mx-0 overflow-x-auto	">
                              <table className="min-w-full divide-y divide-gray-300">
                                <thead>
                                  <tr>
                                    <th
                                      scope="col"
                                      className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0"
                                    >
                                      <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                        ITEM DETAILS
                                      </span>
                                    </th>
                                    <th
                                      scope="col"
                                      className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0"
                                    >
                                      Add
                                    </th>
                                    <th
                                      scope="col"
                                      className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0"
                                    >
                                      DESC
                                    </th>
                                    <th
                                      scope="col"
                                      className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0"
                                    >
                                      HSN/SAC
                                    </th>
                                    <th
                                      scope="col"
                                      className="hidden py-3.5 px-3 text-right text-sm font-semibold text-gray-900 sm:table-cell"
                                    >
                                      QUANTITY
                                    </th>
                                    <th
                                      scope="col"
                                      className="hidden py-3.5 px-3 text-right text-sm font-semibold text-gray-900 sm:table-cell"
                                    >
                                      RATE
                                    </th>
                                    <th
                                      scope="col"
                                      className="hidden py-3.5 px-3 text-right text-sm font-semibold text-gray-900 sm:table-cell"
                                    >
                                      TAX
                                    </th>
                                    <th
                                      scope="col"
                                      className="py-3.5 pl-3 pr-4 text-right text-sm font-semibold text-gray-900 sm:pr-6 md:pr-0"
                                    >
                                      AMOUNT
                                    </th>
                                    <th
                                      scope="col"
                                      className="py-3.5 pl-3 pr-4 text-right text-sm font-semibold text-gray-900 sm:pr-6 md:pr-0"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-5 w-5"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path d="M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z" />
                                      </svg>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.enquire_item.map(
                                    (Itemsi, index) => (
                                      <tr
                                        key={index}
                                        className="border-b border-gray-200"
                                      >
                                        <td className="py-4 pl-4 pr-3 text-sm sm:pl-6 md:pl-0">
                                          <Combobox
                                            as="div"
                                            value={Itemsi}
                                            onChange={this.handleInputSelectItem(
                                              index
                                            )}
                                          >
                                            <Combobox.Label className="block text-sm font-medium text-gray-700"></Combobox.Label>
                                            <div className="relative mt-1">
                                              <Combobox.Input
                                                className="w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
                                                onChange={this.handleInputtwo}
                                                displayValue={(Items) =>
                                                  typeof Items.name !==
                                                    "undefined" &&
                                                  Items.name != null
                                                    ? Items.name
                                                    : ""
                                                }
                                              />
                                              <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
                                                <SelectorIcon
                                                  className="h-5 w-5 text-gray-400"
                                                  aria-hidden="true"
                                                />
                                              </Combobox.Button>

                                              {filteredItem.length > 0 && (
                                                <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                                  {filteredItem.map(
                                                    (itemLine) => (
                                                      <Combobox.Option
                                                        key={itemLine.id_crypt}
                                                        value={itemLine}
                                                        className={({
                                                          active,
                                                        }) =>
                                                          classNames(
                                                            "relative cursor-default select-none py-2 pl-3 pr-9",
                                                            active
                                                              ? "bg-indigo-600 text-white"
                                                              : "text-gray-900"
                                                          )
                                                        }
                                                      >
                                                        {({
                                                          active,
                                                          selected,
                                                        }) => (
                                                          <>
                                                            <span
                                                              className={classNames(
                                                                "block truncate",
                                                                selected &&
                                                                  "font-semibold"
                                                              )}
                                                            >
                                                              {itemLine.name}
                                                            </span>

                                                            {selected && (
                                                              <span
                                                                className={classNames(
                                                                  "absolute inset-y-0 right-0 flex items-center pr-4",
                                                                  active
                                                                    ? "text-white"
                                                                    : "text-indigo-600"
                                                                )}
                                                              >
                                                                <CheckIcon
                                                                  className="h-5 w-5"
                                                                  aria-hidden="true"
                                                                />
                                                              </span>
                                                            )}
                                                          </>
                                                        )}
                                                      </Combobox.Option>
                                                    )
                                                  )}
                                                </Combobox.Options>
                                              )}
                                            </div>
                                          </Combobox>
                                        </td>
                                        <td className="hidden py-4 px-3 text-right text-sm text-gray-500 sm:table-cell">
                                          <button
                                            type="button"
                                            onClick={this.addItem}
                                            className="float-right mt-4 inline-flex items-center p-.05 border border-transparent rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                          >
                                            <PlusSmIconOutline
                                              className="h-6 w-6"
                                              aria-hidden="true"
                                            />
                                          </button>
                                        </td>
                                        <td className="hidden py-4 px-3 text-right text-sm text-gray-500 sm:table-cell">
                                          <input
                                            type="text"
                                            name="description"
                                            onChange={this.handleInputDescription(
                                              index
                                            )}
                                            value={Itemsi.description}
                                            id="description"
                                            autoComplete="description"
                                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </td>
                                        <td className="hidden py-4 px-3 text-right text-sm text-gray-500 sm:table-cell">
                                          <input
                                            type="number"
                                            name="hsn_code"
                                            onChange={this.handleInputSelecthsn_code(
                                              index
                                            )}
                                            value={Itemsi.hsn_code}
                                            id="hsn_code"
                                            autoComplete="hsn_code"
                                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </td>
                                        <td className="hidden py-4 px-3 text-right text-sm text-gray-500 sm:table-cell">
                                          <input
                                            type="number"
                                            name="quantity"
                                            onChange={this.handleInputSelectquantity(
                                              index
                                            )}
                                            value={Itemsi.quantity}
                                            id="quantity"
                                            autoComplete="quantity"
                                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </td>

                                        <td className="hidden py-4 px-3 text-right text-sm text-gray-500 sm:table-cell">
                                          <input
                                            type="number"
                                            name="rate"
                                            onChange={this.handleInputAmount(
                                              index
                                            )}
                                            value={Itemsi.rate}
                                            id="rate"
                                            autoComplete="rate"
                                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </td>
                                        <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                          <select
                                            id="enquireTax"
                                            name="enquireTax"
                                            value={Itemsi.enquire_tax_id}
                                            onChange={this.handleenquiretax(
                                              index
                                            )}
                                            autoComplete="enquireTax"
                                            className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                          >
                                            <option value="0">------</option>
                                            {this.state.enquireTaxlist.map(
                                              (number, index) => (
                                                <option value={number.id}>
                                                  {number.name}
                                                </option>
                                              )
                                            )}
                                          </select>
                                          <p
                                            className="mt-2 text-sm text-red-600"
                                            id="contact_person_email_address-error"
                                          >
                                            {this.ItemErrorfetch(
                                              this.state.error_list,
                                              index
                                            )}
                                          </p>
                                        </td>
                                        <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                          {Itemsi.amount}
                                        </td>
                                        <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            onClick={this.itemDelete(
                                              index,
                                              Itemsi.id
                                            )}
                                            className="h-6 w-6"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                          >
                                            <path
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                                            />
                                          </svg>
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                                <tfoot>
                                  <tr>
                                    <td>
                                      <button
                                        type="button"
                                        className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                        onClick={this.addLine}
                                      >
                                        <PlusIcon
                                          className="-ml-1 mr-2 h-5 w-5"
                                          aria-hidden="true"
                                        />
                                        Add New Line
                                      </button>
                                    </td>
                                  </tr>
                                  <tr>
                                    <th
                                      scope="row"
                                      colSpan={4}
                                      className="hidden pl-6 pr-3 pt-6 text-right text-sm font-normal text-gray-500 sm:table-cell md:pl-0"
                                    >
                                      Subtotal
                                    </th>
                                    <th
                                      scope="row"
                                      className="pl-4 pr-3 pt-6 text-left text-sm font-normal text-gray-500 sm:hidden"
                                    >
                                      Subtotal
                                    </th>
                                    <td className="pl-3 pr-4 pt-6 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                      {this.state.sub_total}
                                    </td>
                                  </tr>

                                  {this.state.enquire_item.map(
                                    (Itemsi, index) =>
                                      Itemsi.gst_igst_common_value === 2 ? (
                                        <tr>
                                          <th
                                            scope="row"
                                            colSpan={4}
                                            className="hidden pl-6 pr-3 pt-4 text-right text-sm font-normal text-gray-500 sm:table-cell md:pl-0"
                                          >
                                            IGST
                                            {Itemsi.igst_percentage}
                                          </th>
                                          <th
                                            scope="row"
                                            className="pl-4 pr-3 pt-4 text-left text-sm font-normal text-gray-500 sm:hidden"
                                          >
                                            {Itemsi.igst_percentage}
                                          </th>
                                          <td className="pl-3 pr-4 pt-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                            {" "}
                                            {Itemsi.igst_amount}
                                          </td>
                                        </tr>
                                      ) : (
                                        ""
                                      )
                                  )}

                                  {this.state.enquire_item.map(
                                    (Itemsi, index) =>
                                      Itemsi.gst_igst_common_value === 3 ? (
                                        <tr>
                                          <th
                                            scope="row"
                                            colSpan={4}
                                            className="hidden pl-6 pr-3 pt-4 text-right text-sm font-normal text-gray-500 sm:table-cell md:pl-0"
                                          >
                                            GST {Itemsi.cgst_percentage * 2}%
                                          </th>
                                          <th
                                            scope="row"
                                            className="pl-4 pr-3 pt-4 text-left text-sm font-normal text-gray-500 sm:hidden"
                                          >
                                            GST {Itemsi.cgst_percentage * 2}%
                                          </th>

                                          <td className="pl-3 pr-4 pt-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                            CGST:{Itemsi.cgst_amount}
                                          </td>

                                          <td className="pl-3 pr-4 pt-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                            SGST:{Itemsi.sgst_amount}
                                          </td>
                                        </tr>
                                      ) : (
                                        ""
                                      )
                                  )}

                                  <tr>
                                    <th
                                      scope="row"
                                      colSpan={4}
                                      className="hidden pl-6 pr-3 pt-4 text-right text-sm font-semibold text-gray-900 sm:table-cell md:pl-0"
                                    >
                                      Total
                                    </th>
                                    <th
                                      scope="row"
                                      className="pl-4 pr-3 pt-4 text-left text-sm font-semibold text-gray-900 sm:hidden"
                                    >
                                      Total
                                    </th>
                                    <td className="pl-3 pr-4 pt-4 text-right text-sm font-semibold text-gray-900 sm:pr-6 md:pr-0">
                                      {
                                        //this.state.total=this.state.totalTax+this.state.sub_total

                                        (this.state.total =
                                          this.state.totalTax +
                                          this.state.sub_total)
                                      }
                                    </td>
                                  </tr>
                                </tfoot>
                              </table>
                            </div>
                          </div>
                        </div>

                        <div className="pt-8">
                          <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                            <div className="sm:col-span-3">
                              <label
                                htmlFor="customer_notes"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Customer Notes
                              </label>
                              <div className="mt-1">
                                <textarea
                                  rows={2}
                                  name="customer_notes"
                                  id="customer_notes"
                                  value={this.state.customer_notes}
                                  onChange={this.handleInputenquiredetails}
                                  className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                  defaultValue={""}
                                />
                              </div>
                            </div>
                            <div className="sm:col-span-3">
                              <label
                                htmlFor="terms_conditions"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Terms & Conditions
                              </label>
                              <div className="mt-1">
                                <textarea
                                  rows={2}
                                  name="terms_conditions"
                                  value={this.state.terms_conditions}
                                  id="terms_conditions"
                                  onChange={this.handleInputenquiredetails}
                                  className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                  defaultValue={""}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="px-4 py-3 bg-gray-50 text-right sm:px-3">
                        <button
                          type="submit"
                          className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            {/* /End replace */}
          </div>
        </div>

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <CheckCircleIcon
                        className="h-6 w-6 text-green-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        {this.state.message1}
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
        {/**/}

        {/**/}
        {/*add customer */}
        <Transition.Root show={this.state.opencustomer} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-10"
            onClose={this.closecustomer}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end lg:items-center  justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8  md:max-w-screen-md lg:max-w-screen-lg sm:w-full sm:p-6">
                    <div>
                      <Customercreatemodal
                        handleInputenquire={this.handleInputModal}
                      />
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
        {/*add customer*/}
        {/*add Cusotmer vehiclee */}

        {/*add vechicle*/}
        {/*Item customer*/}
        <Transition.Root show={this.state.openitem} as={Fragment}>
          <Dialog as="div" className="relative z-10" onClose={this.closeItem}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end lg:items-center  justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8  md:max-w-screen-md lg:max-w-screen-lg sm:w-full sm:p-6">
                    <div>
                      <ItemModalcreate
                        handleInputenquireItem={this.handleInputModalForItem}
                      />
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>

        {/*Item customer*/}
        {/**/}
        {/** stock messsage*/}
        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showstockmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <XCircleIcon
                        className="h-6 w-6 text-red-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        {this.state.stockmsg}
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showstockmsg: false, stockmsg: "" });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
        {/** */}
      </>
    );
  }
}

export default (props) => <EnquireEdit {...props} params={useParams()} />;
